var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsViewTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.333 1.667c.428 0 .78.321.828.736l.006.097L4.166 5H7.5a.833.833 0 0 1 .097 1.661l-.097.006H4.166v6.666c0 .427.321.78.737.828l.097.006h2.5a.833.833 0 0 1 .097 1.66l-.097.006H5a2.5 2.5 0 0 1-2.496-2.353l-.004-.147V2.5c0-.46.373-.833.833-.833zm9.734-.834-.168.007a2.038 2.038 0 0 0-1.315.615l-.829.835a.835.835 0 0 0-.163.131c-.382.396-.592.92-.592 1.47v3.192c0 1.146.933 2.084 2.083 2.084h3.334c1.143 0 2.083-.94 2.083-2.084V2.917c0-1.15-.938-2.084-2.083-2.084h-2.35zm0 1.667h2.35a.42.42 0 0 1 .416.417v4.166a.426.426 0 0 1-.416.417h-3.334a.42.42 0 0 1-.416-.417V3.892l.005-.071a.44.44 0 0 1 .04-.13l.011-.021.077-.067.975-.983a.389.389 0 0 1 .292-.12zm2.35 8.333-2.35.001-.168.007a2.038 2.038 0 0 0-1.315.614l-.826.833a.835.835 0 0 0-.166.133c-.382.396-.592.92-.592 1.47v3.192c0 1.146.933 2.084 2.083 2.084h3.334c1.143 0 2.083-.94 2.083-2.084v-4.166a2.087 2.087 0 0 0-1.947-2.08l-.137-.004zm-2.35 1.668 2.35-.001a.42.42 0 0 1 .416.417v4.166a.426.426 0 0 1-.416.417h-3.334a.42.42 0 0 1-.416-.417v-3.191l.005-.071a.44.44 0 0 1 .04-.13l.01-.018.078-.069.975-.983a.389.389 0 0 1 .292-.12z",
    fill: "#4B5563",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsViewTree);
export default __webpack_public_path__ + "static/media/icons-view-tree.f12b268aca309d45cd53c687c20bca60.svg";
export { ForwardRef as ReactComponent };